// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__riGow","requiredAsterisk":"Info_requiredAsterisk__3vwvo"};